import DetalleConsulta from "./DetalleConsulta";
import { Grid } from "@material-ui/core";
import MeditocInfoField from "../../../utils/MeditocInfoField";
import MeditocModal from "../../../utils/MeditocModal";
import MeditocTable from "../../../utils/MeditocTable";
import { getDetalleDoctorColumns } from "../../../../models/ReporteDoctorModel";
import { useReporteDoctor } from "../../../../context/ReporteDoctorContext";

export default function DetalleDoctor() {
    const {
        listaConsultas,
        doctorSeleccionado,
        consultaSeleccionada,
        modalOpenDetalleDoctor,
        handleOpenDetalleDoctor,
        handleChangeConsultaSeleccionada,
    } = useReporteDoctor();

    return (
        <MeditocModal
            size="large"
            title="Detalle de doctor"
            open={modalOpenDetalleDoctor}
            setopen={handleOpenDetalleDoctor}
            okmessage="Cerrar detalle de doctor"
            hidecancel
        >
            <Grid container spacing={3}>
                <Grid item sm={4} xs={12}>
                    <MeditocInfoField label="Nombre del Doctor:" value={doctorSeleccionado.sNombre} />
                </Grid>
                <Grid item sm={4} xs={12}>
                    <MeditocInfoField label="Tipo de Doctor:" value={doctorSeleccionado.sTipoDoctor} />
                </Grid>
                <Grid item sm={4} xs={12}>
                    <MeditocInfoField label="Especialidad:" value={doctorSeleccionado.sEspecialidad} />
                </Grid>
                <Grid item sm={4} xs={12}>
                    <MeditocInfoField label="Teléfono:" value={doctorSeleccionado.sTelefono} />
                </Grid>
                <Grid item sm={4} xs={12}>
                    <MeditocInfoField label="Correo Electrónico:" value={doctorSeleccionado.sCorreo} />
                </Grid>
                <Grid item sm={4} xs={12}>
                    <MeditocInfoField
                        label="Dirección de Consultorio:"
                        value={doctorSeleccionado.sDireccionConsultorio}
                    />
                </Grid>
                <Grid item sm={4} xs={12}>
                    <MeditocInfoField label="Número de Sala Icelink:" value={doctorSeleccionado.iNumSala} />
                </Grid>
                <Grid item sm={4} xs={12}>
                    <MeditocInfoField label="Total de consultas:" value={doctorSeleccionado.iTotalConsultas} />
                </Grid>
                <Grid item xs={12}>
                    <MeditocTable
                        id="iIdConsulta"
                        data={listaConsultas}
                        row={consultaSeleccionada}
                        columns={getDetalleDoctorColumns()}
                        setRow={handleChangeConsultaSeleccionada}
                    />
                </Grid>
            </Grid>
            <DetalleConsulta />
        </MeditocModal>
    );
}
